import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MappingMode } from "../../../../../models/auto-generated";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone:false,
  templateUrl: "./permission-mapping-settings.component.html"
})
export class PermissionMappingSettingsComponent implements OnInit {
  MappingMode = MappingMode;

  formGroup: UntypedFormGroup;

  errorMessage: string;
  isReadOnly: boolean;
  mappingMode: MappingMode;
  saveCallback: (mappingMode: MappingMode) => void;

  constructor(public activeModal: NgbActiveModal, private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      mappingMode: this.fb.control(this.mappingMode)
    });
  }

  save() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
    } else {
      this.saveCallback(this.formGroup.getRawValue().mappingMode);
    }
  }
}
